import * as React from 'react';
import {FC, ReactNode} from 'react';
import {Field} from 'react-final-form';

interface Props {
  children: (values: any) => ReactNode
  fieldNames: string[]
}

// https://github.com/mhryshkin/react-final-form-values-subscription
const FormSpyFieldValues: FC<Props> = ({ children, fieldNames }) => (
  <React.Fragment>
    {fieldNames.reduce(
      (acc, fieldName) => (values) => (
        <Field name={fieldName} subscription={{ value: true }}>
          {({ input: { value } }) => acc({ ...values, [fieldName]: value })}
        </Field>
      ),
      children
    )({})}
  </React.Fragment>
);

const MemoizedFormSpyFieldValues = React.memo(
  FormSpyFieldValues,
  (prevProps, nextProps) => Array.isArray(prevProps.fieldNames) === Array.isArray(nextProps.fieldNames)
);

export default MemoizedFormSpyFieldValues;
